import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { supabase } from '../lib/supabase'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const error = ref(null)
  const isAuthenticated = computed(() => !!user.value)

  function getDevBypassUser() {
    const bypassEnabled =
      import.meta.env.VITE_DEV_AUTH_BYPASS === 'true' ||
      localStorage.getItem('dev-auth-bypass') === 'true'

    if (!bypassEnabled) return null

    const testUserId =
      import.meta.env.VITE_DEV_TEST_USER_ID || '369c76b4-fa01-4e29-b87c-cbfe879c1989'

    return {
      id: testUserId,
      email: 'fraiponts@gmail.com',
      user_metadata: {
        name: 'Test Hans',
        full_name: 'Test Hans'
      }
    }
  }

  async function checkAuth() {
    const devUser = getDevBypassUser()
    if (devUser) {
      user.value = devUser
      error.value = null
      return
    }

    try {
      const {
        data: { user: authUser },
        error: fetchError
      } = await supabase.auth.getUser()

      if (fetchError) {
        // Ignore missing session errors which occur when the user isn't logged in
        if (fetchError.name !== 'AuthSessionMissingError') {
          console.error('Auth error:', fetchError)
          error.value = fetchError.message
        } else {
          error.value = null
        }
        user.value = null
      } else {
        user.value = authUser
        error.value = null
      }
    } catch (err) {
      console.error('Unexpected error during auth check:', err)
      error.value = err.message
      user.value = null
    }
  }

  async function signInWithEmail(email) {
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: window.location.origin
      }
    })
    if (error) {
      error.value = error.message
      throw error
    }
  }

  async function signInWithGoogle() {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin
      }
    })
    if (error) {
      error.value = error.message
      throw error
    }
  }

  async function signOut() {
    await supabase.auth.signOut()
    user.value = null
    // Redirect to login after successful logout
    if (typeof window !== 'undefined') {
      window.location.href = '/login'
    }
  }

  supabase.auth.onAuthStateChange((event, session) => {
    user.value = session?.user ?? null
  })

  return {
    user,
    isAuthenticated,
    checkAuth,
    signInWithEmail,
    signInWithGoogle,
    signOut,
    error
  }
})
